<template>
  <div class="wrapper" id="wrapper">
    <!--余额浮窗-->
    <div class="coin-tab">
      <span>金币余额</span>
      <span>{{ totalMoneyCoin }}</span>
    </div>
    <div class="header">
      <!--返回|退出按钮-->
      <div class="go-back" @click="goBack" />
    </div>
    <div class="redpack-content">
      <!--规则按钮-->
      <div class="rule-content">
        <p @click="ruleShow = !ruleShow">活动规则</p>
      </div>
       <!--图片标题-->
      <div class="title" />
      <!--时间进度-->
      <div class="time-content">
          <div class="time-list">
            <div v-for="(item, index) in showHour" :key="index" class="time-item" :class="index == 0 ? 'first': index == 1 ? 'current' : 'other'">
              <span>{{item}}红包</span>
            </div>

          </div>
          <!--时间进度条进度-->
          <div class="time-progress">
            <span/>
          </div>
      </div>
      <div class="big-redpack" @click="showAds()">
        <div>{{currentTime}}发出定时红包</div>
        <div>本时段红包总价值</div>
        <div>
          <span v-for="(item, index) in TotalMoneyArr" :key="index">
            <countTo :startVal="0" :endVal="parseInt(item)" :duration="3000" />
          </span>
          <span class="big-redpack-unit">万金币</span>
        </div>
        <div>共<countTo :startVal="0" :endVal="parseInt(hourTotalNum)" :duration="2000" />个红包，<countTo :startVal="0" :endVal="parseInt(hourTotalPeople)" :duration="2000" />人同时抢</div>
        <div>
          <img src="~@/assets/images/day_redpack/finger.gif" />
        </div>
      </div>
       <div class="my-record-btn" @click="showUserRecord()">
        <img src="~@/assets/images/day_redpack/record.png" />我的红包记录
      </div>
      <div class="redpack-receive-record">
        <div class="record-title">{{currentTime}}红包领取名单</div>
        <div class="record-list">
          <vue-seamless-scroll
          :data="rewardReceiveList"
          :class-option="seamlessScrollOption"
          style="height: 4.4rem;overflow:hidden;"
          >
            <div v-for="(item, index) in rewardReceiveList" :key="index" class="record-item" >
              <span><img :src="item.avatar" /></span>
              <span>
                <b>{{item.nickname}}</b>
                <b>{{item.date}}</b>
              </span>
              <span>+{{item.money_coin}}</span>
              <span></span>
            </div>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>

    <!--规则弹窗-->
    <van-popup v-model="ruleShow" :close-on-click-overlay=false>
      <div class="introduce">
        <div class="title">活动规则明细</div>
        <div class="close" @click="ruleShow = false"/>
        <div class="rule_info">
          <div v-html="ruleTxt"/>
        </div>
      </div>
    </van-popup>

    <!--红包加载中-->
    <van-popup v-model="rloadShow" :close-on-click-overlay=false>
      <div class="redpack-loading">
        <span><img src="~@/assets/images/day_redpack/rloading.png" /></span>
        <span>红包加载中…</span>
        <span>广告播放完毕即可获得红包</span>
      </div>
    </van-popup>

     <!--红包记录弹窗-->
    <van-popup v-model="recordShow" :close-on-click-overlay=false>
      <div class="popup-record">
        <div class="popup-record-title">我的红包记录</div>
        <div class="popup-record-close" @click="recordShow = false"/>
        <div class="popup-record-info">
          <div class="popup-record-list" v-if="userRecordList.length > 0">
            <div v-for="(item, index) in userRecordList" :key="index" class="popup-record-item" >
              <span><img src="~@/assets/images/day_redpack/rclose.png" /></span>
              <span>
                <b>{{item.title}}</b>
                <b>{{item.sub_title}}</b>
              </span>
              <span>+{{item.reward_money_coin}}</span>
            </div> 
          </div>
          <div v-else class="popup-record-list">
            <div class="popup-record-empty">你还没有领取红包记录哦~</div>
          </div>
        </div>
      </div>
    </van-popup>

    <!--红包奖励弹窗-->
    <van-popup v-model="rewardShow" :close-on-click-overlay=false>
      <div class="reward-popup" :class="hasCplAd == false ? 'bbz': ''">
        <div class="reward-popup-close" @click="resetVal(1)"/>
        <div class="top-bg" />
        <div class="reward-popup-info">
          <div class="reward-popup-top">
            <span>
              <img :src="userAvatar" />
              {{userName}}
            </span>
            <span>恭喜发财，大吉大利</span>
            <span>{{rewardMoneyCoin}}<b>金币</b></span>
            <span>红包已存入金币余额</span>
            <!-- <span @click="toUserCenter()">红包已存入<a>我的账户</a></span> -->
          </div>
          <div v-if="hasCplAd" class="reward-popup-task">
            <div class="reward-popup-content">
              <span>试玩以下任务，立即再赚<b>{{recommendAd.first_money ? recommendAd.first_money : recommendAd.money}}元</b></span>
              <span @click="toCpl(recommendAd.jump_url)">
                <img :src="recommendAd.icon" />
                {{recommendAd.title}}
              </span>
              <span>请务必按照任务说明完成试玩任务奖励实时到账哦！</span>
              <span @click="toCpl(recommendAd.jump_url)">立即赚钱</span>
              <span @click="resetVal(2)">继续领红包</span>
              <span @click="changeCpl()">换一个</span>
            </div>
            <span class="reward-popup-extra">额外奖励</span>
          </div>
          <div v-else class="reward-popup-no-task">
              <span @click="resetVal(2)">立即赚钱</span>
              <span @click="resetVal(2)">继续领红包</span>
          </div>
        </div>
      </div>
    </van-popup>

    <!--加载中-->
    <loading :isLoad="isLoad" />
  </div>
</template>

<script>
import Vue from "vue";
import { Popup, Toast } from "vant";
import VueSeamlessScroll from "vue-seamless-scroll"; // 垂直滚动插件
import countTo from 'vue-count-to'; // 数字滚动效果
Vue.use(Popup).use(Toast);
Vue.use(VueSeamlessScroll);
import Loading from "@/components/Loading"; // 加载中组件
export default {
  name: "DayRedpack",
  components: {
    Loading,
    countTo
  },
  data() {
    return {
      userId: '',
      deviceid: '',
      appVersion: '',
      appId: '',
      appName: '',
      totalMoney: 0.00,
      totalMoneyCoin: 0,
      wrapperWidth: 540,
      isLoad: false, // 加载中
      ruleShow: false, // 规则弹窗
      rloadShow: false, // 红包加载中弹窗
      recordShow: false, // 用户领取记录弹窗
      rewardShow: false, // 奖励结算弹窗
      ruleTxt:"1.每天每小时不间断由平台随机个数现金红包<br><br>2.用户点击抢红包按钮。观看激励视频即可获取一次抢红包机会<br><br>3.系统随机根据用户每次抢红包的记录下发随机金额的现金红包到用户个人账户<br><br>4.用户所抢到的现金红包达到提现要求后，可直接提现到微信<br><br>5、若平台技术检测出用户使用非法手段，技术手段等方式获取红包，平台有权利直接将用户账户清零<br><br>6.本活动最终解释权归平台所有",
      rewardReceiveList: [], // 随机记录名单
      userRecordList: [], // 用户领取红包记录
      code: "", //红包领取code
      tipsConfigTxt: "", // 激励视频浮窗提示文案
      showHour: [], //时间刻度列表
      TotalMoneyArr: [0], // 奖池总金额数字数组
      hourTotalMoney: 0, // 奖池总金额
      hourTotalPeople: 0, // 时间段人数
      hourTotalNum: 0, // 时间段红包数
      currentTime: "", // 当前时间刻度
      recommendAd: [], // cpl广告
      userAvatar: "", // 用户头像
      userName: "", // 用户昵称
      rewardMoney: 0.0, // 奖励金额
      rewardMoneyCoin: 0,
      cpls: [], //所有推荐cpl广告列表
      userCenterUrl: 'lezhuan://jump?type=8', // 提现页面（我的账户）
      hasCplAd: true, // 是否有推荐cpl广告
    };
  },
  computed: {
    // 记录滚动配置
    seamlessScrollOption() {
      return {
        step: 1.5, // 数值越大速度滚动越快
        limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: (this.wrapperWidth/540) * 106.55, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      };
    }
  },
  created() {
    this.userid = this.getCookie("userid");
    this.deviceid = this.getCookie("device_id");
    this.appVersion = this.getCookie("app_version");
    this.appId = this.getCookie("app_id");
    if (this.$route.query.debug == 1) {
      this.userid = this.$route.query.userid;
      this.deviceid = this.$route.query.device_id;
      this.appVersion = this.$route.query.app_version;
      this.appId = this.$route.query.app_id;
      this.appName = this.$route.query.app_name;
    }
    // 获取转盘数据
    this.getData(1);
  },
  mounted() {
    // 播放广告回调
    window.playH5AdResult = res => {
      console.log(res, "广告数据回调");
      // 播放广告完成
      if (parseInt(res) == 1) {
        this.complete(); // 广告播放成功 发放奖励
      } else {
       this.rloadShow = false; // 隐藏红包加载框
        this.toast("奖励领取失败:播放广告失败");
      }
    };
    window.addEventListener('resize', this.getWindowResize, false) // 监听屏幕尺寸变化
  },
  methods: {
    // 监控屏幕尺寸变化
    getWindowResize () {
      let wrapper = document.getElementById('wrapper').getBoundingClientRect()
      this.wrapperWidth = wrapper.width
      console.log(this.wrapperWidth)
    },
    // 获取cookie值
    getCookie(name) {
      var strcookie = document.cookie; //获取cookie字符串
      var arrcookie = strcookie.split("; "); //分割
      //遍历匹配
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name) {
          return arr[1];
        }
      }
      return "";
    },
    // 调用客户端方法
    callClienFunc(fname, fval) {
      console.log(fname, fval, 111);
      if (window.hasOwnProperty("injectedObject")) {
        window.injectedObject.setJsContent(fname, JSON.stringify(fval));
      } else {
        fval = fval ? fval : {};
        let params = { method: fname, params: fval };
        params = JSON.stringify(params);
        window.Android.postMessage(params);
      }
    },
    // 关闭页面
    goBack() {
      this.callClienFunc("closeWebview", "");
    },
    // 跳转到app链接页面
    toApp(url) {
      window.location.href = url
    },
    // 自定义toast 样式自定义
    toast(message) {
      Toast({ message: message, className: "toast-spin-win" });
    },
    // 跳转到我的账户
    toUserCenter () {
      this.toApp(this.userCenterUrl);
    },
    // 跳转到cpl页面
    toCpl(url) {
      this.toApp(url);
    },
    // 获取奖励数字数组
    getTotalMoneyArr(money) {
      if (money <= 0) {
        this.TotalMoneyArr = [0];
        return;
      }
      let sNumber = money + "";
      let data = [];
      for (let i = 0, len = sNumber.length; i < len; i += 1) {
        data.push(+sNumber.charAt(i));
      }
      this.TotalMoneyArr = data;
    },
    // 展示广告
    showAds() {
      console.log("开始播放广告");
      this.rloadShow = true;
      let params = {
        adType: "4", // 4 激励视频
        adCode: "", // 广告代码位
        tips: this.tipsConfigTxt
      };
      this.callClienFunc("playH5Ad", params);
      //this.complete();
    },
    // cpl广告换一换
    changeCpl() {
      let cpls = this.cpls;
      if (cpls.length <= 0) {
        return [];
      }
      let n = Math.floor(Math.random() * cpls.length + 1) - 1;
      this.recommendAd = cpls[n];
    },
    // 重置数据(关闭奖励结算弹窗)
    resetVal(type) {
      type = parseInt(type)
      this.rewardMoney = 0;
      this.rewardMoneyCoin = 0;
      this.rewardShow = false;
      this.rloadShow = false;
      this.recommendAd = [];
      this.cpls = [];
      this.userAvatar = "";
      this.userName = "";
      this.getData(type);
    },
    // 广告播放完成 发放奖励
    complete() {
      console.log("开始调用接口发放奖励");
      let params = {
        app_version: this.appVersion,
        userid: this.userid,
        app_id: this.appId,
        device_id: this.deviceid,
        code: this.code
      };
      // http://gametest.lushihudong.com/api/user_web/day_red_envelopes_receive
      this.$http
        .get(
          "/api/user_web/day_red_envelopes_receive",
          {
            params: params
          }
        )
        .then(res => {
          this.rloadShow = false;   
          if (res.code == 1) {
            this.rewardMoney = res.data.money ? res.data.money : 0.0; // 奖励金额
            this.rewardMoneyCoin = res.data.money_coin ? res.data.money_coin : 0;
            this.rewardShow = true; // 显示奖励弹窗

            // if (res.data && res.data.recommend_ad) {
            //   this.cpls = res.data.recommend_ad; // 所有cpl广告列表
            //   this.hasCplAd = true;
            // } else {
            //   this.hasCplAd = false;
            // }
            this.hasCplAd = false;
            //this.changeCpl();
            this.userAvatar = res.data.avatar;
            this.userName = res.data.nickname;
            this.totalMoney = res.data.total_money
            this.totalMoneyCoin = res.data.total_money_coin
          } else {
            this.toast("奖励领取失败:" + res.message); //领取失败弹出错误信息
            this.getData(1);
          }
        });
    },
    // 获取用户领取记录
    showUserRecord() {
      let params = {
        app_version: this.appVersion,
        userid: this.userid,
        app_id: this.appId,
        device_id: this.deviceid
      };
      // http://gametest.lushihudong.com/api/user_web/day_red_envelopes_receive_note
      this.isLoad = true;
      this.$http
        .get(
          "/api/user_web/day_red_envelopes_receive_note",
          {
            params: params
          }
        )
        .then(res => {
          if (res.code == 1) {
            this.userRecordList = res.data;
            this.recordShow = true;
          } else {
            this.toast("查询失败:" + res.message); //弹出错误信息
          }
          this.isLoad = false;
        });
    },
    getData(type) {
      type = parseInt(type) != 2 ? 1 : 2;
      let params = {
        app_version: this.appVersion,
        userid: this.userid,
        app_id: this.appId,
        app_name: this.appName,
        device_id: this.deviceid
      };
      // http://gametest.lushihudong.com/api/user_web/day_red_envelopes_index
      this.isLoad = true;
      this.$http
        .get(
          "/api/user_web/day_red_envelopes_index",
          {
            params: params
          }
        )
        .then(res => {
          if (res.code == 1) {
            this.code = res.data.code ? res.data.code : "";
            if (res.data.explain_txt) {
              this.ruleTxt = res.data.explain_txt;
            }
            this.tipsConfigTxt = res.data.tips_config.video_txt
              ? res.data.tips_config.video_txt
              : "";
            this.hourTotalMoney = res.data.hour_total_money;
            this.hourTotalPeople = res.data.hour_total_people;
            this.hourTotalNum = res.data.hour_total_num;
            this.showHour = res.data.show_hour;
            this.rewardReceiveList = res.data.receive_note;
            this.getTotalMoneyArr(this.hourTotalMoney);
            this.currentTime = this.showHour[1];
            this.userid = res.data.userid
            this.totalMoney = res.data.total_money
            this.totalMoneyCoin = res.data.total_money_coin

            // 点继续领红包按钮 继续播放视频开红包
            if (type == 2)(
              this.showAds()
            )
          } else {
            this.toast("查询失败:" + res.message); //弹出错误信息
          }
          this.isLoad = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.wrapper {
  font-family:PingFang-SC-Regular,Helvetica Neue,Helvetica,microsoft yahei,sans-serif;
  position: relative;
  display: block;
  width: 100%;
  max-width: 3.75rem;
  min-height: 100vh;
  background-image: linear-gradient(90deg, #f80658 0%, #f80b0b 100%);
  overflow: hidden;

  /**余额信息浮窗 */
  .coin-tab {
    position: fixed;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    width: 0.7rem;
    height: 0.52rem;
    background: url("~@/assets/images/spin_win/coin_tab.png") no-repeat;
    background-size: 0.7rem 0.52rem;
    z-index: 3000;
    top: 1.66rem;
    right: 0;
    span {
      padding-left: .06rem;
      color: #FFFFFF;
      font-weight: bold;
    }

    span:first-child {
      font-size: 0.12rem;
    }
    span:nth-child(2) {
      font-size: 0.18rem;
    }
  }

  /** 顶部 */
  .header {
    position: absolute;
    display: flex;
    top: 0.38rem;
    width: calc(100% - 0.32rem);
    height: 0.22rem;
    padding: 0 0.16rem;
    justify-content: space-between;
    align-items: center;
    z-index: 72;

    /** 返回|退出按钮 */
    .go-back {
      display: block;
      width: 0.09rem;
      height: 0.16rem;
      background: url("~@/assets/images/high_reward/back.png");
      background-size: 0.09rem 0.16rem;
    }
  }

  /**红包内容 */
  .redpack-content {
    position: relative;
    display: flex;
    flex-flow: column;
    align-items: center;
    width: 100%;
    margin-top: 0.56rem;
    background: url("~@/assets/images/day_redpack/bg.png") no-repeat;
    background-size: 3.75rem 7.2rem;

    /**规则 */
    .rule-content {
      display: block;
      position: absolute;
      right: 0;
      top: 0.1rem;
      overflow: hidden;
      p {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 0.34rem;
        height: 0.9rem;
        color: #ffffff;
        font-size: 0.16rem;
        background: rgba(0, 0, 0, 0.2);
        writing-mode: tb-rl;
        border-radius: 0.08rem 0 0 0.08rem;
        letter-spacing: 0.02rem;
        overflow: hidden;
      }
    }

    /**标题 */
    .title {
      display: block;
      width: 2.7rem;
      height: 0.8rem;
      background: url("~@/assets/images/day_redpack/title.png") no-repeat;
      background-size: 2.7rem 0.8rem;
      margin: 0.1rem 0 0.12rem 0;
    }

    /**时间进度 */
    .time-content {
      position: relative;
      display: flex;
      width: calc(100% - 0.32rem);
      justify-content: center;
      align-items: flex-end;
      margin-top: 0.12rem;
      .time-list {
        display: flex;
        padding: 0 0.1rem;
        z-index: 1;
        .time-item {
          display: flex;
          flex-flow: column;
          align-items: center;
          span:first-child {
            display: flex;
            justify-content: center;
            text-align: center;
            align-items: flex-end;
            width: 0.68rem;
            height: 0.56rem;
            font-size: 0.12rem;
            color: #910017;
            padding-bottom: 0.01rem;
          }
        }
        .time-item.other {
          background: url("~@/assets/images/day_redpack/rclose.png") no-repeat;
          background-size: 0.26rem 0.3rem;
          background-position: center top;
        }
        .time-item.first {
          background: url("~@/assets/images/day_redpack/ropen.png") no-repeat;
          background-size: 0.26rem 0.3rem;
          background-position: center top;
        }
        .time-item.current {
          background: url("~@/assets/images/day_redpack/rclose.png") no-repeat;
          background-size: 0.26rem 0.3rem;
          background-position: center top;
        }
        .time-item.current span {
          background: url("~@/assets/images/day_redpack/pao.png") no-repeat;
          background-size: 0.68rem 0.21rem;
          background-position: center bottom;
        }
      }
      .time-progress {
        position: absolute;
        display: flex;
        align-items: center;
        background: rgba(199, 33, 16, 0.3);
        border-radius: 0.1rem;
        width: 100%;
        height: 0.1rem;
        top: 0.11rem;
        span:first-child {
          position: absolute;
          background: #ffe073;
          width: 1.05rem;
          height: 0.1rem;
          border-radius: 0.1rem;
          left: 0;
        }
      }
    }

    /**大红包 */
    .big-redpack {
      position: relative;
      display: flex;
      flex-flow: column;
      align-items: center;
      width: calc(100% - 1rem);
      padding: 0.4rem 0.5rem;
      height: 3.7rem;
      margin-top: -0.14rem;
      background: url("~@/assets/images/day_redpack/big_redpack.png") no-repeat;
      background-size: 4rem 4.3rem;
      background-position: top center;
      div:first-child {
        position: absolute;
        font-size: 0.16rem;
        letter-spacing: 0.02rem;
        color: #ffffff;
        top: 0.76rem;
      }
      div:nth-child(2) {
        position: absolute;
        top: 2.32rem;
        color: #910017;
        font-size: 0.14rem;
      }
      div:nth-child(3) {
        position: absolute;
        top: 2.62rem;
        color: #ffffff;
        font-size: 0.24rem;
        display: flex;
        span:first-child {
          margin-left: 0.1rem;
        }
        span {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 0.27rem;
          height: 0.36rem;
          border-radius: 0.04rem;
          margin-right: 0.08rem;
          background: rgba(0, 0, 0, 0.1);
          font-weight: bold;
        }
        span:last-child {
          background: transparent;
          font-weight: normal;

        }
        .big-redpack-unit {
          font-size: 0.14rem!important;
          width: 0.42rem;
        }
      }
      div:nth-child(4) {
        position: absolute;
        bottom: 1.05rem;
        color: #ffe796;
        font-size: 0.12rem;
        padding: 0.05rem 0.16rem;
        background: rgba(0, 0, 0, 0.1);
        border-radius: 0.5rem;
        letter-spacing: .01rem;
      }
      div:nth-child(5) {
        position: absolute;
        top: 37%;
        right: 31%;
        img {
          width: 0.7rem;
          height: 0.7rem;
        }
      }
    }

    /** 我的领取记录按钮 */
    .my-record-btn {
      display: flex;
      align-items: center;
      position: absolute;
      top: 46.5%;
      color: #ffffff;
      font-size: 0.14rem;
      z-index: 99;
      img {
        margin-right: 0.05rem;
        width: 0.17rem;
        height: 0.16rem;
      }
    }

    /**红包领取名单 */
    .redpack-receive-record {
      position: relative;
      display: flex;
      justify-content: center;
      width: calc(100% - 0.4rem);
      background-image: linear-gradient(180deg, #fff8d4 13%, #ffd856 100%);
      box-shadow: 0 0.03rem 0.04rem 0 rgba(217, 31, 0, 0.9);
      border-radius: 0.18rem;
      padding: 0.04rem;
      margin: 0 0 0.16rem 0;

      .record-title {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: -0.059rem;
        width: 2.07rem;
        height: 0.42rem;
        color: #910017;
        font-size: 0.16rem;
        background: url("~@/assets/images/day_redpack/rtitle.png") no-repeat;
        background-size: 2.07rem 0.42rem;
        z-index: 1;
      }
      .record-list {
        position: relative;
        display: flex;
        flex-flow: column;
        width: 100%;
        height: 4.4rem;
        justify-content: center;
        background: #ffffff;
        border-radius: 0.14rem;
        padding-top: 0.42rem;
        overflow: hidden;
        .record-item {
          display: flex;
          position: relative;
          align-items: center;
          width: calc(100% - 0.32rem);
          height: 0.46rem;
          padding: 0.14rem 0.16rem;
          span:first-child {
            img {
              width: 0.38rem;
              height: 0.38rem;
              border-radius: 0.38rem;
            }
          }
          span:nth-child(2) {
            display: flex;
            flex-flow: column;
            margin: 0 0.12rem;
            width: calc(100% - 1.22rem);
            b:first-child {
              font-size: 0.16rem;
              color: #333333;
              font-weight: normal;
              margin-bottom: 0.05rem;
            }
            b:nth-child(2) {
              font-size: 0.12rem;
              color: #999;
              font-weight: normal;
            }
          }
          span:nth-child(3) {
            width: 1rem;
            text-align: right;
            font-size: 0.16rem;
            color: #f80933;
            font-weight: bold;
          }
          span:nth-child(4) {
            position: absolute;
            width: calc(100% - 0.32rem);
            height: 0.01rem;
            background: #fafafa;
            bottom: 0;
          }
        }
      }
    }
  }

  /**规则弹窗 */
  .introduce {
    position: relative;
    display: flex;
    justify-content: center;
    width: 3.27rem;
    min-height: 3.26rem;
    margin: 0.106rem 0 0.5rem 0;
    padding: 0.04rem;
    background-image: linear-gradient(180deg, #fff8d4 13%, #ffd856 100%);
    border-radius: 0.16rem;
    .title {
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      top: -0.058rem;
      width: 2.07rem;
      height: 0.42rem;
      background: url("~@/assets/images/day_redpack/rtitle.png") no-repeat;
      background-size: 2.07rem 0.42rem;
      font-size: 0.16rem;
      color: #910017;
    }
    .close {
      position: absolute;
      display: flex;
      width: 0.3rem;
      height: 0.3rem;
      background: url("~@/assets/images/spin_win/redpack_close.png") no-repeat;
      background-size: 0.3rem 0.3rem;
      bottom: -0.5rem;
    }
    .rule_info {
      display: flex;
      width: 100%;
      min-height: 3.26rem;
      border-radius: 0.12rem;
      background: #ffffff;
      padding: 0.48rem 0 .2rem 0;
      div:first-child {
        display: flex;
        width: 100%;
        padding: 0 0.2rem;
        height: 3.2rem;
        font-size: 0.16rem;
        color: #333;
        overflow-y: auto;
        line-height: 0.22rem;
      }
    }
  }
  /** 红包加载中弹窗 */
  .redpack-loading {
    display: flex;
    flex-flow: column;
    align-items: center;
    span:first-child {
      margin-bottom: 0.22rem;
      img {
        width: 0.64rem;
        height: 0.75rem;
      }
    }
    span:nth-child(2),
    span:nth-child(3) {
      margin-bottom: 0.06rem;
      font-size: 0.16rem;
      color: #ffffff;
      width: 2rem;
      text-align: center;
    }
  }

  /**红包领取记录弹窗 */
  .popup-record {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    background-image: linear-gradient(180deg, #fff8d4 13%, #ffd856 100%);
    border-radius: 0.16rem;
    width: 3.27rem;
    min-height: 3.26rem;
    margin: .106rem 0 .5rem 0;
    padding: 0.04rem;
    .popup-record-title {
      position: absolute;
      top: -0.058rem;
      width: 2.07rem;
      height: 0.42rem;
      background: url("~@/assets/images/day_redpack/rtitle.png") no-repeat;
      background-size: 2.07rem 0.42rem;
      font-size: 0.16rem;
      color: #910017;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .popup-record-close {
      position: absolute;
      display: flex;
      width: 0.3rem;
      height: 0.3rem;
      background: url("~@/assets/images/spin_win/redpack_close.png") no-repeat;
      background-size: 0.3rem 0.3rem;
      bottom: -0.5rem;
      z-index: 88;
    }
    .popup-record-empty {
      display:flex;
      font-size: .14rem;
      color: #999;
      justify-content: center;
      align-items: center;
      margin-top: .3rem;
    }
    .popup-record-info {
      display: flex;
      padding-top: 0.44rem;
      padding-bottom: 0.2rem;
      width: 100%;
      background: #ffffff;
      border-radius: 0.12rem;
    }
    .popup-record-list {
      display: flex;
      flex-flow: column;
      width: 100%;
      height: 3.26rem;
      border-radius: 0.12rem;
      overflow-y: auto;
      .popup-record-item {
        display: flex;
        position: relative;
        align-items: center;
        width: calc(100% - 0.48rem);
        height: 0.4rem;
        padding: 0.1rem 0.24rem;
        span:first-child {
          img {
            width: 0.26rem;
            height: 0.3rem;
          }
        }
        span:nth-child(2) {
          display: flex;
          flex-flow: column;
          margin: 0 0.08rem;
          width: calc(100% - 1.02rem);
          b:first-child {
            font-size: 0.14rem;
            color: #333333;
            font-weight: normal;
            margin-bottom: 0.02rem;
          }
          b:nth-child(2) {
            font-size: 0.1rem;
            color: #999;
            font-weight: normal;
          }
        }
        span:nth-child(3) {
          width: 1rem;
          text-align: right;
          font-size: 0.16rem;
          color: #f80933;
          font-weight: bold;
        }
      }
    }
  }

  /** 红包奖励弹窗 */
  
  .reward-popup {
    display: flex;
    justify-content: center;
    position: relative;
    background-image: linear-gradient(180deg, #ff443b 3%, #ff5741 100%);
    border-radius: 0.18rem;
    width: 3.27rem;
    height: 5.12rem;
    .top-bg {
      position: absolute;
      top: 0;
      right: 0;
      width: 3.27rem;
      height: 1.03rem;
      background: url("~@/assets/images/day_redpack/redpack_bg.png") no-repeat;
      background-size: 3.03rem 1.03rem;
    }
    .reward-popup-close {
      position: absolute;
      right: 0.16rem;
      top: 0.16rem;
      width: 0.17rem;
      height: 0.17rem;
      background: url("~@/assets/images/day_redpack/close2.png") no-repeat;
      background-size: 0.17rem 0.17rem;
      z-index: 88;
    }
    .reward-popup-info {
      display: flex;
      align-items: center;
      flex-flow: column;
      padding: 0.16rem;
      justify-content: flex-start;
      .reward-popup-top {
        position: absolute;
        top: 0.24rem;
        display: flex;
        align-items: center;
        flex-flow: column;
        span:nth-child(1) {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 0.16rem;
          color: #fff;
          img {
            width: 0.32rem;
            height: 0.32rem;
            border-radius: 0.32rem;
            margin-right: 0.1rem;
          }
        }
        span:nth-child(2) {
          margin-top: 0.16rem;
          font-size: 0.16rem;
          color: #ffdaaf;
        }
        span:nth-child(3) {
          font-size: 0.42rem;
          color: #ffffff;
          font-weight: bold;
          margin: 0.1rem 0 0.05rem 0;
          b {
            font-size: 0.2rem;
          }
        }
        span:nth-child(4) {
          font-size: 0.12rem;
          color: #910017;
          a {
            text-decoration: underline;
          }
        }
      }
      .reward-popup-task {
        position: absolute;
        bottom: 0.16rem;
        display: flex;
        align-items: center;
        flex-flow: column;
        background: #ffffff;
        box-shadow: 0 0.02rem 0.06rem 0 rgba(124, 0, 10, 0.7);
        border-radius: 0.08rem;
        width: 2.77rem;
        height: 2.74rem;
        padding: 0.09rem;
        .reward-popup-extra {
          position: absolute;
          top: 0;
          right: 0;
          border-radius: 0 0.08rem 0 0.08rem;
          background-color: #ffdaaf;
          color: #a7694e;
          font-size: 0.12rem;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0.04rem 0.08rem;
        }
        .reward-popup-content {
          position: relative;
          display: flex;
          align-items: center;
          width: 100%;
          height: 2.74rem;
          flex-flow: column;
          border: 0.01rem solid #fdebc1;
          border-radius: 0.08rem;

          span:nth-child(1) {
            margin-top: 0.3rem;
            color: #333;
            font-size: 0.16rem;
            font-weight: bold;
            b {
              color: #ff493c;
            }
          }

          span:nth-child(2) {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.16rem;
            color: #333333;
            margin-top: 0.22rem;
            img {
              width: 0.44rem;
              height: 0.44rem;
              margin-right: 0.08rem;
              border-radius: .08rem;
            }
          }

          span:nth-child(3) {
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            width: 1.8rem;
            font-size: 0.12rem;
            color: #ff5d51;
            margin-top: 0.16rem;
          }
          span:nth-child(4) {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 2.28rem;
            height: 0.44rem;
            border-radius: 0.44rem;
            font-size: 0.22rem;
            color: #fff;
            background: #ff493c;
            margin-top: 0.16rem;
          }
          span:nth-child(5) {
            font-size: 0.14rem;
            color: #8f4c36;
            margin-top: 0.1rem;
          }
          span:nth-child(6) {
            position: absolute;
            top: 0;
            left: 0;
            border-radius: 0.08rem 0 0.08rem 0;
            background-color: #4ea6ff;
            color: #fff;
            font-size: 0.12rem;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0.04rem 0.08rem;
          }
        }
      }
    }
  }
  .reward-popup.bbz {
    
    height: 3.2rem;
    .reward-popup-no-task {
      position: absolute;
      top: 2.2rem;
      width: 2.28rem;
      span:first-child {
        display: flex;
        align-items: center;
        justify-content:center;
        width: 2.28rem;
        height: .44rem;
        font-size: .16rem;
        font-weight: bold;
        text-shadow: 0 .01rem 0 rgba(255,255,255,0.60);
        color: #9E5433;
        letter-spacing: .0225rem;
        background-image: linear-gradient(0deg, #fff7d4 0%, #ffd959 100%);
        box-shadow: 0 2px 8px 0 rgba(221,38,3,0.94), inset 0 1px 7px 0 #FFB5A1;
        border-radius: .27rem;
      }
      span:nth-child(2) {
        display: flex;
        justify-content:center;
        font-size: .14rem;
        color: #ffffff;
        margin-top: .11rem;
       }
    }
  }
}
/deep/.van-popup {
  background: transparent;
}
</style>